import apiClient from '@/shared/services/apiClient';

export interface NewsItem {
  id: number;
  title: string;
  body: string;
  is_published: boolean;
  scheduled_for: string | null;
  published_at: string | null;
  created_at: string;
  updated_at: string;
}

export async function getPublishedNews(limit = 10): Promise<NewsItem[]> {
  const res = await apiClient.get('/news', { params: { limit } });
  return res.data.items;
}

export async function listAllNews(page = 1): Promise<{ items: NewsItem[]; total: number }> {
  const res = await apiClient.get('/admin/news', { params: { page } });
  return res.data;
}

export async function createNewsItem(data: {
  title: string;
  body: string;
  is_published?: boolean;
  scheduled_for?: string | null;
}): Promise<NewsItem> {
  const res = await apiClient.post('/admin/news', data);
  return res.data;
}

export async function updateNewsItem(
  id: number,
  data: Partial<{
    title: string;
    body: string;
    is_published: boolean;
    scheduled_for: string | null;
  }>,
): Promise<NewsItem> {
  const res = await apiClient.put(`/admin/news/${id}`, data);
  return res.data;
}

export async function deleteNewsItem(id: number): Promise<void> {
  await apiClient.delete(`/admin/news/${id}`);
}
